export default __webpack_public_path__ + "static/dynamicpage-img-9922fbaef5abd254ba934395c3805041.jpg";